import { useEffect, useState } from 'react';
import NotFound from 'pages/NotFound/NotFound';

export default function Login() {
  const [isError, setErrorFlag] = useState(false);

  useEffect(() => {
    const dashboardUrl = import.meta.env['VITE_DASHBOARD_URL'];
    if (dashboardUrl) window.location.assign(dashboardUrl);
    else setErrorFlag(true);
  }, []);

  return isError ? <NotFound /> : null;
}
